import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Badge, Box } from '@mui/material'
import useAlert from "../../hooks/useAlert";
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import useStyle from './style'
import usePedido from "../../hooks/usePedido";
import { PositionTooltip, TooltipInformacao } from '../TooltipInformacao'
import { styled } from '@mui/material/styles';

const Cart = () => {

    const { showAlertError, showAlertInfo } = useAlert();
    const { user } = useAuth();
    const navigation = useNavigate();
    const classes = useStyle();
    const { alertInfoPedido, errorsPedido, quantidadePedido, itensPedido, loading: loadingPedido } = usePedido();
    const [redirectChecked, setRedirectChecked] = useState(false);

    const StyledBadge = styled(Badge)(({ theme }) => ({
        '& .MuiBadge-badge': {
            color: "white"
        },
    }));

    const handleChangeURL = (event) => {
        event.preventDefault();
        if (!!itensPedido)
            navigation("/carrinho");
    }

    // EFFECT PARA REDIRECIONAR APÓS LOGIN QUANDO TIVER ITENS NO CARRINHO
    useEffect(() => {
        // Verifica se acabou de fazer login
        const justLoggedIn = sessionStorage.getItem('justLoggedIn');
        
        if (justLoggedIn === 'true' && user && !redirectChecked) {
            console.log("Verificando redirecionamento após login...");
            console.log("Loading pedido:", loadingPedido);
            console.log("Itens no carrinho:", itensPedido);
            console.log("Quantidade:", quantidadePedido);
            
            // Função para verificar e redirecionar
            const checkAndRedirect = () => {
                if (itensPedido?.itens?.length > 0 || quantidadePedido > 0) {
                    console.log("✅ Redirecionando para o carrinho!");
                    sessionStorage.removeItem('justLoggedIn');
                    setRedirectChecked(true);
                    navigation("/carrinho");
                } else if (itensPedido !== undefined && !loadingPedido) {
                    console.log("❌ Sem itens no carrinho, não vai redirecionar");
                    sessionStorage.removeItem('justLoggedIn');
                    setRedirectChecked(true);
                }
            };
            
            // Se já carregou, verifica imediatamente
            if (!loadingPedido && itensPedido !== undefined) {
                checkAndRedirect();
            } else {
                // Aguarda 1 segundo para o carregamento
                console.log("⏳ Aguardando carregamento do pedido...");
                const timer = setTimeout(() => {
                    console.log("⏰ Timeout atingido, verificando novamente...");
                    checkAndRedirect();
                }, 1000);
                
                return () => clearTimeout(timer);
            }
        }
    }, [user, itensPedido, quantidadePedido, navigation, loadingPedido, redirectChecked]);

    useEffect(() => {
        if (!!alertInfoPedido) {
            showAlertInfo(alertInfoPedido)
            return;
        }

        if (!!errorsPedido) {
            showAlertError(errorsPedido)
        }

    }, [alertInfoPedido, errorsPedido])

    return <>

        <Box sx={{ mr: 2, cursor: "pointer" }} className={classes.customIconButton} onClick={itensPedido?.itens?.length > 0 ? handleChangeURL : null} >
            <StyledBadge badgeContent={quantidadePedido} color="primary">
                {(itensPedido?.itens?.length > 0) ?
                    <TooltipInformacao sx={{ marginRight: -1 }} positionStart={PositionTooltip.bottom} descricao="Confira os itens que você selecionou">
                        <ShoppingCartIcon />
                    </TooltipInformacao>
                    :

                    <TooltipInformacao sx={{ marginRight: -1 }} positionStart={PositionTooltip.bottom} descricao="Você não possui nenhum item no carrinho">
                        <ShoppingCartIcon />
                    </TooltipInformacao>
                }
            </StyledBadge>
        </Box>
    </>;
}

export default Cart;